import { newVersionMiddleware } from '@/adapters/newVersionMiddleware';
import {
  DefaultApi as RocApi,
  Configuration as RocConfiguration
} from '@/types/referral-outbound-center';

function createPublicRocConfiguration(
  sessionToken?: string,
  invitationToken?: string
) {
  return new RocConfiguration({
    basePath: import.meta.env.VITE_API_BASE_PATH_ROC,
    accessToken: sessionToken,
    headers: invitationToken
      ? { 'X-Invitation-Token': invitationToken }
      : undefined,
    middleware: [
      {
        post: async ({ response }) => newVersionMiddleware(response)
      }
    ]
  });
}

export function createPublicRocClient(
  sessionToken?: string,
  invitationToken?: string
) {
  return new RocApi(
    createPublicRocConfiguration(sessionToken, invitationToken)
  );
}
